<template>
    <component
        :is="banner.url ? Link : 'div'"
        :href="banner.url ?? undefined"
        :style="{ gridColumn: `span ${colSpan}` }"
        class="block h-full w-full overflow-hidden"
    >
        <img v-if="banner.image_url" :src="imageSrc" :alt="`Banner image ${banner.position}`" loading="lazy" class="size-full object-cover" />
    </component>
</template>

<script setup lang="ts">
import type { CategoryBannerObject } from '@/types/generated';
import { Link } from '@inertiajs/vue3';
import { useBreakpoints } from '@vueuse/core';
import { computed, onMounted, ref } from 'vue';

const props = defineProps<{
    banner: CategoryBannerObject;
    maxCols: { mobile: number; desktop: number };
}>();

const breakpoints = useBreakpoints({ lg: 1024 });
const isDesktop = breakpoints.greaterOrEqual('lg');
const isMounted = ref(false);

onMounted(() => {
    isMounted.value = true;
});

// Before mount, default to desktop to match SSR output (provideSSRWidth uses 1280px).
const useDesktop = computed((): boolean => (isMounted.value ? isDesktop.value : true));

const imageSrc = computed((): string => {
    if (!useDesktop.value && props.banner.image_url_mobile) {
        return props.banner.image_url_mobile;
    }

    return props.banner.image_url;
});

const colSpan = computed((): number => {
    const size = useDesktop.value ? props.banner.desktop_size : props.banner.mobile_size;
    const max = useDesktop.value ? props.maxCols.desktop : props.maxCols.mobile;

    return Math.min(size, max);
});
</script>
